<template>
  <div 
    id="water_consumption_ship"
    class="water_consumption"
  >
    <div 
      v-if="receivedData"
      class="water_consumption-item"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="line"
          index-axis="x"
          :id="'water_consumption_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
    <div 
      v-if="receivedData"
      class="water_consumption-item"
    >
      <CastomGraphic
          :received-data="receivedData[1]"
          graph-type="line"
          index-axis="x"
          :id="'water_consumption_ship-2'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'WaterConsumption',
  
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'water_consumption',
      cloneElementId: 'water_consumption_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '64,65').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .water_consumption {
    display: flex;

    &-item {
      margin-right: 20px;
      width: 45%;
    }
  }
</style>